import { Flex } from 'components/layout';
import React from 'react';
import { useMainProviderContext } from 'context/main/provider';
import { IconType, LP_DESIGN_SOCIAL_MEDIA, SocialIcon } from './SocialIcons';
import {
  CovideoLogoBlack,
  CovideoLogoGreenPrimary,
  CovideoLogoWhite,
  CovideoLogoWhiteGreen,
  CdkLogoWhite,
  CdkLogoDark,
} from './assets';
import { FooterContainer } from './styles';

export enum LP_DESIGN_LOGO {
  // COVIDEO
  WHITE = 'white',
  BLACK = 'black',
  COLOR = 'color',
  COLOR_WHITE_TEXT = 'color_white_text',
  // CDK
  CDK_WHITE = 'cdk_white',
  CDK_BLACK = 'cdk_black',
}

const logoSize = { width: 100, height: 32 };
const cdkLogoSize = { width: 100, height: 40 };

const LOGO_TYPE = {
  // COVIDEO
  [LP_DESIGN_LOGO.WHITE]: <CovideoLogoWhite {...logoSize} />,
  [LP_DESIGN_LOGO.BLACK]: <CovideoLogoBlack {...logoSize} />,
  [LP_DESIGN_LOGO.COLOR]: <CovideoLogoGreenPrimary {...logoSize} />,
  [LP_DESIGN_LOGO.COLOR_WHITE_TEXT]: <CovideoLogoWhiteGreen {...logoSize} />,
  // CDK
  [LP_DESIGN_LOGO.CDK_WHITE]: <CdkLogoWhite {...cdkLogoSize} />,
  [LP_DESIGN_LOGO.CDK_BLACK]: <CdkLogoDark {...cdkLogoSize} />,
};

export const LandingFooter = () => {
  const { response, isBuilderPreviewMode } = useMainProviderContext();
  const { landingPageDesign, socialLinks } = response;

  const showSocialMediaIcons = Boolean(landingPageDesign.showSocialMediaIcons);
  const showFooterShadow = !!landingPageDesign.showFooterShadow;
  return (
    <FooterContainer
      footerBackgroundColor={landingPageDesign?.footerBackgroundColor}
      showFooterShadow={showFooterShadow}
    >
      <Flex gap='16px' alignItems='center' justifyContent='center'>
        {showSocialMediaIcons &&
          !!socialLinks.length &&
          !isBuilderPreviewMode && (
            <Flex
              flexDirection='row'
              gap='6px'
              justifyContent='center'
              flexWrap='wrap'
              style={{ boxSizing: 'border-box' }}
            >
              {socialLinks.map(icon => {
                return (
                  <a
                    href={icon.path}
                    key={icon.path}
                    target={'_blank'}
                    rel='noreferrer'
                    style={{ fontSize: 0 }}
                  >
                    <SocialIcon
                      size={35}
                      svgSize={23}
                      icon={icon.name.toLowerCase() as IconType}
                      design={
                        landingPageDesign.socialMediaIconType ??
                        LP_DESIGN_SOCIAL_MEDIA.WHITE_SQUARE
                      }
                    />
                  </a>
                );
              })}
            </Flex>
          )}
        {LOGO_TYPE[landingPageDesign.footerLogo]}
      </Flex>
    </FooterContainer>
  );
};
